export default class RedirectInstruction {
  constructor(to, isPermanent = false, reload = false) {
    this.to = to;
    this.isPermanent = isPermanent;
    this.reload = reload;
  }
}
